// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3sw8s","title":"_2G5Ei","content":"KoWdE"};